module.exports = __webpack_public_path__ + "static/lars-5d63e550765cfffeefde2f226967f219.png";